import 'regenerator-runtime/runtime';
import React from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import history from './configureHistory';
import { render } from 'react-dom';
import Home from '../directmodel/components/Home';
import Enroll from '../directmodel/components/Enroll';
import Terms from '../directmodel/components/Terms';
import validateGivingFundData from '../ppgf/components/ValidatedComponent';
import TabsPanel from '../ppgf/components/TabsPanel';
import EnrollWrapper from '../ppgf/components/EnrollWrapper';

const validateCountry = (document.getElementsByTagName('html')[0].getAttribute('country')).toUpperCase();
const domainCC = window.location.pathname.split('/')[1].toUpperCase();
let countryCode = '';

if (validateCountry === domainCC) {
	countryCode = '/' + validateCountry;
}

let routes = [{ path: countryCode + '/givingfund/activity', component: validateGivingFundData(TabsPanel) },
{ path: countryCode + '/givingfund/dashboard', component: validateGivingFundData(TabsPanel) },
{ path: countryCode + '/givingfund/', component: Home },
{ path: countryCode + '/givingfund/home', component: Home },
{ path: countryCode + '/givingfund/enroll', component: validateGivingFundData(EnrollWrapper) },
{ path: countryCode + '/givingfund/profile/:intent', component: Enroll },
{ path: countryCode + '/givingfund/profile', component: validateGivingFundData(TabsPanel) },
{ path: countryCode + '/givingfund/termsandconditions', component: Terms }];
let routeComponents = routes.map(({ path, component, page }, key) => <Route exact path={path} page={page} component={component} key={key} />);
render((
	<Router history={history}>
		<Switch>
			{routeComponents}
		</Switch>
	</Router>
), document.getElementById('givingfundWrapper'));
